module.exports = __webpack_public_path__ + "img/faq-categories.5a3d3ac.svg";